import { render, staticRenderFns } from "./MaterialBaseExtendTaskPage.vue?vue&type=template&id=5ef032d8&scoped=true&"
import script from "./MaterialBaseExtendTaskPage.vue?vue&type=script&lang=js&"
export * from "./MaterialBaseExtendTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef032d8",
  null
  
)

export default component.exports